import { type ComponentRef, useRef, useState } from 'react';
import '../../../css/translations.css';
import translations from '../translations';
import Loader from './loader/Loader';
import TranslationBase from './translations/TranslationsBase';

interface Props {
    isActive: boolean;
}

const Translations = ({ isActive }: Props) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const modalContainerRef = useRef<ComponentRef<'div'>>(null);

    return (
        <div className="translations" ref={modalContainerRef}>
            {isProcessing && <Loader message={translations.COMMON_processing} />}
            <TranslationBase
                container={modalContainerRef.current}
                setIsProcessing={(isProcessing: boolean) => setIsProcessing(isProcessing)}
                isActive={isActive}
            />
        </div>
    );
};

export default Translations;
